'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showAvailabilityMessageInWidget = undefined;

var _reselect = require('reselect');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _getIsUnassignedResponderInWidget = require('../../responders/selectors/getIsUnassignedResponderInWidget');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var showAvailabilityMessageInWidget = exports.showAvailabilityMessageInWidget = (0, _reselect.createSelector)([_getSelectedThreadId.getSelectedThreadId, _getIsUnassignedResponderInWidget.getIsUnassignedResponderInWidget, _historyDataForThread.historyDataForThread], function (selectedThreadId, isUnassigned, history) {
  var isInThreadView = selectedThreadId !== null;

  if (isInThreadView && !history) {
    window.Raven.captureMessage('NO_HISTORY_FOUND_FOR_THREAD', {
      extra: {
        threadId: selectedThreadId
      },
      level: 'info'
    });
  }

  return isInThreadView && isUnassigned && Boolean(history) && (0, _hasMessages.hasMessages)(history);
});